<template>
  <div>
    <HeadBanner :itemData="$store.state.selected_menu" />
    <Breadcrumb />
    <WidgetSlider/>
    <UsefulTools class="p-b"
      :itemData="_.get(this.$store.state.current_content, 'secondary.usefull_tools.conf')"
      v-if="_.get(this.$store.state.current_content, 'secondary.usefull_tools.conf.enabled')==1"
      :firstLook="4"
      :ipadLook="3"
    />
    <ReasonsSlider
      v-if="_.get(this.$store.state.current_content, 'secondary.ReasonsSlider.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.ReasonsSlider')"
    />
    <ProductsSlider
      v-if="_.get(this.$store.state.current_content, 'secondary.ProductsSlider.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.ProductsSlider')"
    />
    <MoreWaysForBanking />
  </div>
</template>


<script>
import HeadBanner from "@/components/HeadBanner";
import Breadcrumb from "@/components/Breadcrumb";
import WidgetSlider from "@/components/WidgetSlider";
import UsefulTools from "@/components/UsefulTools";
import ReasonsSlider from "@/components/ReasonsSlider";
import ProductsSlider from "@/components/ProductsSlider";
import MoreWaysForBanking from "@/components/MoreWaysForBanking";

export default {
  components: {
    HeadBanner,
    Breadcrumb,
    WidgetSlider,
    UsefulTools,
    ReasonsSlider,
    ProductsSlider,
    MoreWaysForBanking,
  },
};
</script>

<style>
  .reasonsSliderContainer.p-b{
    padding-bottom: 90px !important;
  }
</style>
